import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "Footer" }
const _hoisted_2 = { class: "Footer_Top" }
const _hoisted_3 = { class: "Footer_Contact" }
const _hoisted_4 = { class: "Footer_Title" }
const _hoisted_5 = { class: "Footer_ContactInfo" }
const _hoisted_6 = { class: "Footer_Text" }
const _hoisted_7 = ["href"]
const _hoisted_8 = { class: "Footer_Text" }
const _hoisted_9 = { class: "Footer_Social" }
const _hoisted_10 = ["href", "aria-label"]
const _hoisted_11 = ["src"]
const _hoisted_12 = ["aria-label"]
const _hoisted_13 = { class: "Footer_Title" }
const _hoisted_14 = { class: "Footer_SiteMapList" }
const _hoisted_15 = ["href"]
const _hoisted_16 = { class: "Footer_Newsletter" }
const _hoisted_17 = { class: "Footer_Title" }
const _hoisted_18 = { class: "Footer_Text" }
const _hoisted_19 = ["href"]
const _hoisted_20 = ["src"]
const _hoisted_21 = { class: "Footer_Bottom" }
const _hoisted_22 = { class: "Footer_Legal" }
const _hoisted_23 = ["href"]
const _hoisted_24 = { class: "Footer_Logo" }
const _hoisted_25 = ["srcset"]
const _hoisted_26 = ["src", "alt"]

import translationsData from '@/dictionaries/footer.json';
import navigationData from '@/dictionaries/navigation.json';
import facebookIconUrl from '@/assets/img/icon-facebook-blanc.svg';
import linkedinIconUrl from '@/assets/img/icon-linkedin-blanc.svg';
import youtubeIconUrl from '@/assets/img/icon-youtube-blanc.svg';
import logoHorizontalUrl from '@/assets/img/logo-scene-pro-horizontal-blanc.svg';
import logoStackedUrl from '@/assets/img/logo-scene-pro-grand-blanc.svg';
import chevronRightUrl from '@/assets/img/chevron-droite-blanc.svg';
import { deleteCookie } from '@/services/handleCookies';
import { useCookieConsent } from '@/services/cookieConsent';


export default /*@__PURE__*/_defineComponent({
  __name: 'TheFooterComponent',
  setup(__props) {

const translations = translationsData.fr;
const navigation = navigationData.fr;
const connectionUrl = process.env.VUE_APP_LOGIN_URL;

const { social } = translations.contact;
const { terms, privacy } = translations.legal;

// Links without a URL in the dictionary are not rendered, so no dead "#" link ships
const socialLinks = [
  { ...social.facebook, icon: facebookIconUrl },
  { ...social.linkedin, icon: linkedinIconUrl },
  { ...social.youtube, icon: youtubeIconUrl },
].filter((link) => link.url);
const legalLinks = [terms, privacy].filter((link) => link.url);

const { COOKIE_CONSENT_KEY } = useCookieConsent();

// Deleting the consent cookie makes the cookie banner show up again
const manageCookies = () => {
  deleteCookie(COOKIE_CONSENT_KEY);
  window.dispatchEvent(new Event('cookie-consent-changed'));
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("section", _hoisted_3, [
        _createElementVNode("h2", _hoisted_4, _toDisplayString(_unref(translations).contact.title), 1),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("p", _hoisted_6, [
            _createTextVNode(_toDisplayString(_unref(translations).contact.tel), 1),
            _cache[0] || (_cache[0] = _createElementVNode("br", null, null, -1)),
            _createElementVNode("a", {
              class: "Footer_Link",
              href: `mailto:${_unref(translations).contact.email}`
            }, _toDisplayString(_unref(translations).contact.email), 9, _hoisted_7)
          ]),
          _createElementVNode("p", _hoisted_8, _toDisplayString(_unref(translations).contact.opening), 1)
        ]),
        _createElementVNode("ul", _hoisted_9, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(socialLinks), (link) => {
            return (_openBlock(), _createElementBlock("li", {
              key: link.label
            }, [
              _createElementVNode("a", {
                class: "Footer_SocialLink",
                href: link.url,
                target: "_blank",
                rel: "noopener",
                "aria-label": link.label
              }, [
                _createElementVNode("img", {
                  src: link.icon,
                  alt: "",
                  width: "16",
                  height: "16"
                }, null, 8, _hoisted_11)
              ], 8, _hoisted_10)
            ]))
          }), 128))
        ])
      ]),
      _createElementVNode("nav", {
        class: "Footer_SiteMap",
        "aria-label": _unref(translations).siteMap.title
      }, [
        _createElementVNode("h2", _hoisted_13, _toDisplayString(_unref(translations).siteMap.title), 1),
        _createElementVNode("ul", _hoisted_14, [
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, {
              class: "Footer_Link",
              to: "/"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(navigation).home), 1)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, {
              class: "Footer_Link",
              to: "/a-propos"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(navigation).about), 1)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, {
              class: "Footer_Link",
              to: "/usages"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(navigation).usages), 1)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, {
              class: "Footer_Link",
              to: "/offres-de-spectacles"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(translations).siteMap.showsDirectory), 1)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("a", {
              class: "Footer_Link",
              href: _unref(connectionUrl),
              target: "_blank"
            }, _toDisplayString(_unref(navigation).connexion), 9, _hoisted_15)
          ])
        ])
      ], 8, _hoisted_12),
      _createElementVNode("section", _hoisted_16, [
        _createElementVNode("h2", _hoisted_17, _toDisplayString(_unref(translations).newsletter.title), 1),
        _createElementVNode("p", _hoisted_18, _toDisplayString(_unref(translations).newsletter.text), 1),
        _createElementVNode("a", {
          class: "Footer_Btn",
          href: _unref(translations).newsletter.url,
          target: "_blank",
          rel: "noopener"
        }, [
          _createTextVNode(_toDisplayString(_unref(translations).newsletter.btnText) + " ", 1),
          _createElementVNode("img", {
            class: "Footer_BtnChevron",
            src: _unref(chevronRightUrl),
            alt: "",
            width: "16",
            height: "16"
          }, null, 8, _hoisted_20)
        ], 8, _hoisted_19)
      ])
    ]),
    _createElementVNode("div", _hoisted_21, [
      _createElementVNode("ul", _hoisted_22, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(legalLinks), (link) => {
          return (_openBlock(), _createElementBlock("li", {
            key: link.label
          }, [
            (link.url.startsWith('/'))
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 0,
                  class: "Footer_Link",
                  to: link.url
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(link.label), 1)
                  ]),
                  _: 2
                }, 1032, ["to"]))
              : (_openBlock(), _createElementBlock("a", {
                  key: 1,
                  class: "Footer_Link",
                  href: link.url,
                  target: "_blank",
                  rel: "noopener"
                }, _toDisplayString(link.label), 9, _hoisted_23))
          ]))
        }), 128)),
        _createElementVNode("li", null, [
          _createElementVNode("button", {
            class: "Footer_Link Footer_CookiesBtn",
            type: "button",
            onClick: manageCookies
          }, _toDisplayString(_unref(translations).legal.manageCookies), 1)
        ])
      ]),
      _createElementVNode("picture", _hoisted_24, [
        _createElementVNode("source", {
          srcset: _unref(logoHorizontalUrl),
          media: "(min-width: 992px)",
          width: "1047",
          height: "151"
        }, null, 8, _hoisted_25),
        _createElementVNode("img", {
          src: _unref(logoStackedUrl),
          alt: _unref(translations).logoAlt,
          width: "289",
          height: "157"
        }, null, 8, _hoisted_26)
      ])
    ])
  ]))
}
}

})